import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from '../../services/i18nService';

import styles from './RemoteOralExam.scss';
import remoteOralExamService from '../../services/RemoteOralExamService';
import Topic from './Topic';

const RemoteOralExam = ({ sessionInfo, showTopic }) => {
    const outerClass = showTopic ? styles.splitScreen : '';
    const shouldAnnounceTransition = remoteOralExamService.isInProgress(sessionInfo);

    return (<div className={styles.topicContainer}>
        {shouldAnnounceTransition && (
            <span role="alert" aria-live="assertive" aria-atomic="true" className="sr-only">
                {t('remoteOralExam.liveSession.connectedAnnouncement')}
            </span>
        )}
        <div className={outerClass}>
            { showTopic && <Topic questionId={sessionInfo.contextObjectId} /> }
            <div className={styles.zoomCallPlaceholder} />
        </div>
    </div>);
};

RemoteOralExam.propTypes = {
    sessionInfo: PropTypes.object.isRequired,
    showTopic: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    const { remoteOralExam: { sessionInfo } } = state;

    return {
        sessionInfo,
        showTopic: remoteOralExamService.isDisplayStatusVisible(sessionInfo),
    };
};

export default connect(mapStateToProps)(RemoteOralExam);
